(function () {
    function wrapButtonFace(button) {
        if (!button || button.dataset.vitalifyFaceWrapped === 'true') {
            return;
        }

        var face = document.createElement('span');
        face.className = 'vitalify-review-button__face';

        while (button.firstChild) {
            face.appendChild(button.firstChild);
        }

        button.appendChild(face);
        button.dataset.vitalifyFaceWrapped = 'true';
    }

    function enhance(sectionElement) {
        if (!sectionElement) {
            return;
        }

        var buttons = sectionElement.querySelectorAll('.jm-action-buttons__button, .jm-button--primary, .jdgm-write-rev-link');
        buttons.forEach(wrapButtonFace);

        if (sectionElement._vitalifyJudgeMeObserver) {
            return;
        }

        var observer = new MutationObserver(function () {
            var refreshedButtons = sectionElement.querySelectorAll('.jm-action-buttons__button, .jm-button--primary, .jdgm-write-rev-link');
            refreshedButtons.forEach(wrapButtonFace);
        });

        observer.observe(sectionElement, {
            childList: true,
            subtree: true
        });

        sectionElement._vitalifyJudgeMeObserver = observer;
    }

    window.VitalifyJudgeMe = {
        init: enhance
    };
})();
